import React, { useEffect, useState } from "react";
import { ethers } from "ethers";
import FromNetWork from "./exchangeContent/FromNetWorkContainer";
import ToNetworkContainer from "./exchangeContent/ToNetworkContainer";
import BillContainer from "./billContainer/BillContainer";
import MFEButton from "./moveFundToExeda/MFEButton";
import SwapVert from "../../../assets/responsiveIcons/SwapVert";
import { swapNetworks } from "./components/helper";
import ErrorDisplay from "../../reusable/ErrorDisplay";
import { useConnectWallet, useSetChain } from "@web3-onboard/react";
import ERC20ABI from "../../../assets/abi/erc20_ABI.json"
import CCPoolABI from "../../../assets/abi/ccPoolABI.json"
import CCPoolEdexaABI from "../../../assets/abi/ccPoolEdexaABI.json"
// import { BigNumber } from "ethers";
import useSnackBar from "../../../helper/CallSnackBar";
// import { s } from "framer-motion/client";
import ConnectWalletError from "../../reusable/ConnectWalletError";
// import { type } from "@testing-library/user-event/dist/type";

function BridgeContainer({ netWroks, setNetWroks }) {
  // {netWroks, setNetWroks}
  // const [netWroks, setNetWroks] = useState([...net_works]);
  const [transAmount, setTransAmount] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [swapRotation, setSwapRotation] = useState({
    fist: "rotate-180",
    second: "rotate-0",
  });
  const [{ connectedChain, settingChain }, setChain] = useSetChain();
  const [{ wallet, connecting }] = useConnectWallet();
  const [fromBalance, setFromBalance] = useState(0);
  const [toBalance, setToBalance] = useState(0);

  const [ERC20Contract, setERC20Contract] = useState(null);
  const [CCPoolContract, setCCPoolContract] = useState(null);
  const [isInvalid, setIsInvalid] = React.useState(false);
  const [isPending, setIsPending] = React.useState(false);
  const [message, setMessage] = React.useState("BRIDGE");
  const [lowBalance, setLowBalance] = React.useState(false);
  const { setSnackBar } = useSnackBar();
  const [gasFee, setGasFee] = useState(0);
  const [bridgeFee, setBridgeFee] = useState(0);
  const [count, setCount] = useState(0);
  const [isConnectionError, setIsConnectionError] = useState(false)

  const filterNetworksForFromSection = () => {
    try {
      const arr = [];
      for (let i = 0; i < netWroks.length; i++) {
        const element = netWroks[i];
        if (element.isSelectedAsTo) {
          // continue;
        }
        if (element.isSelectedAsFrom) {
          element.isSelected = true;
          if (netWroks[i].isSelectedAsTo) {
            netWroks[i].isSelectedAsTo = false;
            netWroks.filter(
              (el) => !el.isSelectedAsFrom
            )[0].isSelectedAsTo = true;
          }
        } else {
          element.isSelected = false;
        }
        arr.push(element);
      }
      return arr;
    } catch (e) {
      //  console.log(e)
    }

  };

  const filterNetworksForToSection = () => {
    try {
      const arr = [];
      for (let i = 0; i < netWroks.length; i++) {
        const element = netWroks[i];
        if (element.isSelectedAsFrom) {
          continue;
        }
        if (element.isSelectedAsTo) {
          element.isSelected = true;
        } else {
          element.isSelected = false;
        }
        arr.push(element);
      }
      return arr;
    } catch (e) {
      //  console.log(e) 
    }

  };

  const handleOnClick = async () => {

    try {
      const selectedPickupNetWork = filterNetworksForFromSection().find(    ///////////////// get network's data
        (el) => el.isSelected
      );
      const selectedDestiNetwork = filterNetworksForToSection().find(
        (el) => el.isSelected
      );

      if (!connectedChain) {
        setIsConnectionError(true)
      } else if (transAmount === "" || transAmount <= 0) {
        setMessage("Please enter a valid amount");
        setTimeout(() => {
          setMessage("BRIDGE");
        }, 3000);
        return
      }

      const feeaCheck = await getFees();
      if (!feeaCheck) {
        return;
      }
      console.log("testttt")


      setIsPending(true);
      setMessage("TRANSACTIONS PENDING ...");

      if (!ERC20Contract && !CCPoolContract && !wallet) return;

      updateFromBalance();

      let fee = await CCPoolContract.estimateFee(selectedDestiNetwork.WID, 800000);                   /////////////////// fee
      let tx3;

      try {
        if (connectedChain.id === '0x1530') {
          const amountToSend = ethers.utils.parseEther(transAmount.toString());
          const totalValue = fee.add(amountToSend);


          tx3 = await CCPoolContract.crossTo(selectedDestiNetwork.WID, { value: totalValue });   /////////////////// crossTo

          setSnackBar({ message: "Bridge transaction pending ..", type: "processing" });
          // console.log("tx3", tx3)

          await tx3.wait();
          setSnackBar({ message: "Bridging Success! Please wait few min before balance appear in wallet ", type: "success" });
          updateFromBalance();
          setTransAmount("");
          setIsPending(false)
          setMessage("BRIDGE")
          setTimeout(() => {
            //setSnackBar({});
          }, 10000);
          setCount(count + 1);
          return;

        } else {
          const getAllowance = async () => {
            const allw = await ERC20Contract.allowance(                                     /////////////////// allowance
              wallet.accounts[0].address,
              selectedPickupNetWork.CCpool
            );
            console.log("allw", allw)
            return Number(ethers.utils.formatEther(allw));
          }


          if (await getAllowance() < Number(transAmount)) {

            try {
              setSnackBar({ message: "Please approve amount in wallet", type: "info" });

              /////////////////// approve  
              let tx2 = await ERC20Contract.approve(selectedPickupNetWork.CCpool, ethers.utils.parseEther(transAmount), {
                // gasPrice: ethers.utils.parseUnits('60', 'gwei'),
                // gasLimit: 1000000
              });
              setSnackBar({ message: "Approval transaction pending ..", type: "processing" });
              await tx2.wait();


              let isWrongAmountApproved = false;
              if (await getAllowance() < Number(transAmount)) {
                isWrongAmountApproved = true;
                setSnackBar({ message: "Insufficient approval submitted", type: "danger" });
                setMessage("BRIDGE");
                setIsPending(false);
                setTimeout(() => {
                  //setSnackBar({});
                }, 4000);
                return;
              }

              if (isWrongAmountApproved) return;
              setSnackBar({ message: "Approval success", type: "success" });

              setTimeout(() => {
                setSnackBar({ message: "Please confirm bridge transaction in wallet", type: "info" });

                setTimeout(() => {
                  //setSnackBar({});
                }, 5000);


              }, 2000);

            } catch (error) {
              console.log("error", error)

              if (error?.message?.includes("user rejected transaction")) {
                setSnackBar({ message: "User rejected transaction", type: "danger" });

              } else {
                setSnackBar({ message: "An error occured while approval. Please try again", type: "danger" });
              }
              // console.log(error)
              setIsPending(false)
              setMessage("Bridge")
              setTimeout(() => {
                //setSnackBar({});
              }, 6000);


              return;

            }
          } else {

            setSnackBar({ message: "Please confirm bridge transaction in wallet", type: "info" });
            setTimeout(() => {
              //setSnackBar({});
            }, 6000);

          }
        }

        try {
          tx3 = await CCPoolContract.crossTo(                                     /////////////////// bridge
            selectedDestiNetwork.WID,
            ethers.utils.parseEther(transAmount.toString()),
            {
              value: fee,
            }
          );
        } catch (e) {
          if (e?.message?.includes("insufficient funds for gas * price + value")) {
            // Extract values from the error message using regular expressions
            const regex = /have (\d+) want (\d+)/;
            const match = e.message.match(regex);

            if (match) {
              const availableFunds = ethers.BigNumber.from(match[1]); // Available funds in wei
              const requiredFunds = ethers.BigNumber.from(match[2]); // Required funds in wei

              // Calculate the deficit
              // const deficit = requiredFunds - availableFunds;
              const selectedPickupNetwork = filterNetworksForFromSection().find(
                (el) => el.isSelected
              )
              setSnackBar({ message: `Not enough funds. Minimum of ${Number(ethers.utils.formatEther(requiredFunds)).toFixed(7)} ${selectedPickupNetwork.currency} bridge fee and Gas required`, type: "danger" });
              setTimeout(() => {
                //setSnackBar({});
              }, 8000);
            };
          }
          if (e?.data?.message?.includes("insufficient funds for gas * price + value")) {
            // Extract values from the error message using regular expressions
            const regex = /have (\d+) want (\d+)/;
            const match = e.data.message.match(regex);

            if (match) {
              const availableFunds = ethers.BigNumber.from(match[1]); // Available funds in wei
              const requiredFunds = ethers.BigNumber.from(match[2]); // Required funds in wei

              // Calculate the deficit
              // const deficit = requiredFunds - availableFunds;
              const selectedPickupNetwork = filterNetworksForFromSection().find(
                (el) => el.isSelected
              )
              setSnackBar({ message: `Not enough funds. Minimum of ${Number(ethers.utils.formatEther(requiredFunds)).toFixed(7)} ${selectedPickupNetwork.currency} bridge fee and Gas required`, type: "danger" });
              setTimeout(() => {
                //setSnackBar({});
              }, 8000);
            };

            return false;
          }

        }




        setSnackBar({ message: "Bridge transaction pending ..", type: "processing" });
        // console.log("tx3", tx3)

        await tx3.wait();
        setSnackBar({ message: "Bridging Success! Please wait few min before balance appear in wallet ", type: "success" });
        updateFromBalance();
        setTransAmount("");
        setIsPending(false)
        setMessage("BRIDGE")
        setTimeout(() => {
          //setSnackBar({});
        }, 10000);
        setCount(count + 1);

      } catch (e) {
        // console.log(e)
        if (e?.data?.message?.includes("insufficient funds for transfer")) {
          setSnackBar({ message: `Your wallet dont have enough ${selectedPickupNetWork.currency} to bridge`, type: "danger" });
        } else if (e?.message?.includes("user rejected transaction")) {
          setSnackBar({ message: "User rejected transaction", type: "danger" });
        } else if (e?.data?.message?.includes("Upfront cost exceeds account balance")) {

          setSnackBar({ message: "Upfront cost exceeds account balance", type: "danger" });
        } else if (e?.data?.message?.includes("insufficient funds for gas")) {
          setSnackBar({ message: "Your wallet dont have enough gas to bridge", type: "danger" });
        }
        else {
          setSnackBar({ message: "An error occured while bridging. Please try again", type: "danger" });
        }

        setIsPending(false)
        setMessage("Bridge")
        setTransAmount("");


      }


    } catch (er) {
      // console.log(er);
    }
  };


  async function init() {
    try {
      if (wallet && wallet.chains && connectedChain.id) {
        const chainId = connectedChain.id;
        const walletProvider = new ethers.providers.Web3Provider(wallet?.provider, 'any');
        const signer = walletProvider.getSigner();

        let ERCContract, cc_contract, poolAddress;


        switch (chainId) {
          case "0x1":
            ERCContract = new ethers.Contract("0xC114678C6e4654d041B2006C90f08478b444c4E2", ERC20ABI, signer)
            setERC20Contract(ERCContract);

            poolAddress = "0xdDA61D8611091487eB5d14Ca2f6F24cCE877317e";
            cc_contract = new ethers.Contract(poolAddress, CCPoolABI, signer)
            setCCPoolContract(cc_contract)
            break;

          case "0x89":

            ERCContract = new ethers.Contract("0xC114678C6e4654d041B2006C90f08478b444c4E2", ERC20ABI, signer)
            setERC20Contract(ERCContract);


            poolAddress = "0x7A59786E4C9d6E858bd21f1c050A5184ac2c39b0";
            cc_contract = new ethers.Contract(poolAddress, CCPoolABI, signer);
            setCCPoolContract(cc_contract)
            break;

          case "0x38":

            ERCContract = new ethers.Contract("0xC114678C6e4654d041B2006C90f08478b444c4E2", ERC20ABI, signer)
            setERC20Contract(ERCContract);


            poolAddress = "0xa9Be0cE3393Cda9dfa8A8dfB7CB0e29cF9608DA4"
            cc_contract = new ethers.Contract(poolAddress, CCPoolABI, signer)
            setCCPoolContract(cc_contract)
            break;

          case "0x1530":
            poolAddress = "0x635E175CBaC135Ea029E8333b8BBf2c07e645F13"; //replace with edexa contract address
            cc_contract = new ethers.Contract(poolAddress, CCPoolEdexaABI, signer)
            setCCPoolContract(cc_contract)
            break;

          default: return;

        }

      }
      setCount(count + 1);
    } catch (error) { }
  }


  // async function init(){
  //   try{
  //   if (wallet && wallet.chains&&connectedChain.id) {
  //     const chainId = connectedChain.id;
  //     const walletProvider= new ethers.providers.Web3Provider(wallet?.provider, 'any');
  //     const signer= walletProvider.getSigner();

  //     let ERCContract,cc_contract,poolAddress;



  //                           ERCContract = new ethers.Contract("0xC114678C6e4654d041B2006C90f08478b444c4E2", ERC20ABI, signer)
  //                           setERC20Contract(ERCContract);

  //                           poolAddress = "0x074B8AF8863654Dc2b2c7F12657Ae895e3ABB7d4";
  //                           cc_contract = new ethers.Contract(poolAddress, CCPoolABI, signer)
  //                           setCCPoolContract(cc_contract)




  //      }
  //      setCount(count+1);
  // }catch(error){} 
  // }







  useEffect(() => {
    init();


  }, [wallet, connectedChain, netWroks]);


  useEffect(() => {
    updateFromBalance();
    updateToBalance();


  }, [init]);

  async function updateFromBalance() {
    try {
      if (!wallet?.accounts[0]?.address || connecting || settingChain) { return; }
      if (connectedChain.id === '0x1530') {
        const walletProvider = new ethers.providers.Web3Provider(wallet?.provider, 'any');
        const signer = walletProvider.getSigner();
        const bal = await signer.getBalance();
        setFromBalance(ethers.utils.formatEther(bal));
      } else {
        const bal = await ERC20Contract?.balanceOf(wallet?.accounts[0]?.address);
        setFromBalance(ethers.utils.formatEther(bal));

      }
    } catch (error) {
      //  console.log(error)
    }
  }



  async function updateToBalance() {
    try {
      if (!wallet?.accounts[0]?.address) return;
      let provider, address;
      for (let i = 0; i < netWroks.length; i++) {
        const element = netWroks[i];
        if (element.isSelectedAsTo && element.chainId !== connectedChain.id) {
          provider = new ethers.providers.JsonRpcProvider(element.provider)
          if (element.chainId === '0x1530') {
            const bal = await provider.getBalance(wallet?.accounts[0]?.address);
            setToBalance(ethers.utils.formatEther(bal));
          } else {

            address = element.erc20;
            const temp = new ethers.Contract(address, ERC20ABI, provider);
            setToBalance(ethers.utils.formatEther(await temp.balanceOf(wallet?.accounts[0]?.address)));
          }
        }
      }
    } catch (e) {
      // console.log(e) 
    }
  }



  function formatAmount(amount) {
    // Convert amount to string
    let amountStr = amount.toString();

    // Check if there is a decimal point
    if (amountStr.includes('.')) {
      // Split the string into integer and decimal parts
      let parts = amountStr.split('.');
      // Limit the decimal part to 3 digits
      parts[1] = parts[1].substring(0, 3);
      // Join the parts back together
      return parts.join('.');
    } else {
      // If there's no decimal point, return the amount with '.000'
      return amountStr + '.000';
    }
  }

  const handleClickOnMaxAmout = async (percent) => {
    try {

      updateFromBalance();
      if (Number(fromBalance === 0)) return;
      const amount = formatAmount((fromBalance * percent) / 100);
      setTransAmount(amount.toString());
      setIsInvalid(false)
    } catch (e) {
      // console.log(e) 
    }

  };
  //

  const handleOnSwapClick = async () => {

    try {
      let status = false;
      for (let i = 0; i < netWroks.length; i++) {
        const element = netWroks[i];
        if (element.isSelectedAsTo) {
          try {
            status = await setChain({ chainId: element.chainId });
            // updateFromBalance();
            updateToBalance();

          } catch (e) {
            setIsConnectionError(true)
            // updateFromBalance();
            updateToBalance();
            return  // stop 
          }
        }
      }
      if (!status) return;
      updateToBalance();
      setNetWroks(swapNetworks(netWroks));
      setSwapRotation({ fist: swapRotation.second, second: swapRotation.fist });
    } catch (e) {
      // console.log(e)
    }


  };

  useEffect(() => {

    if (Number(fromBalance) < Number(transAmount)) {
      setLowBalance(true);
      setMessage("Insufficient Balance");
    }
    else {
      setLowBalance(false);
      setMessage("BRIDGE");
    }
  }, [transAmount]);


  useEffect(() => {

    if (!connectedChain) {
      setFromBalance(0);
      setToBalance(0);
    }


  }, [wallet]);



  async function getFees() {

    try {
      const selectedDestiNetwork = filterNetworksForToSection().find(
        (el) => el.isSelected
      );

      if (!CCPoolContract || !selectedDestiNetwork) return;

      let fee = await CCPoolContract?.estimateFee(selectedDestiNetwork.WID, 800000);
      /////////////////// fee
      const fee_in_decimal = ethers.utils.formatEther(fee);
      // console.log("fee_decimal", fee_in_decimal)
      setBridgeFee(Number(fee_in_decimal).toFixed(7));


      let gasEstimate;
      if (connectedChain.id === '0x1530') {
        gasEstimate = 250000;
      }
      else if (connectedChain.id === '0x1') {
        gasEstimate = 140000;
      }
      else if (connectedChain.id === '0x89') {

        gasEstimate = 138438;
      }
      else if (connectedChain.id === '0x38') {
        gasEstimate = 143238;
      }

      const walletProvider = new ethers.providers.Web3Provider(wallet?.provider, 'any');
      const gasPrice = await walletProvider.getGasPrice();
      // console.log("gas price", ethers.utils.formatEther(gasPrice))
      const gasFee = ethers.BigNumber.from(gasEstimate).mul(gasPrice);
      //  console.log("gas____ fee",ethers.utils.formatEther(gasFee))
      const gas_in_decimal = ethers.utils.formatEther(gasFee);
      // console.log("gas_in_decimal",gas_in_decimal)
      setGasFee(Number(gas_in_decimal).toFixed(7));
      setTimeout(() => { setSnackBar({}) }, 2000);
    
      if (connectedChain.id !== '0x1530') {
        await CCPoolContract.estimateGas.crossTo(
          selectedDestiNetwork.WID,
          '0',
          {
            value: fee
          }
        )
      }else{
       updateFromBalance()
        if(Number(fromBalance)<(Number(fee_in_decimal)+Number(gas_in_decimal))){
          setSnackBar({message:"Insufficient EDX balance for bridge",type:"danger"})
          return
        }
          
      }
      return true;

    } catch (e) {
      if (e?.message?.includes("insufficient funds for gas * price + value")) {
        // Extract values from the error message using regular expressions
        const regex = /have (\d+) want (\d+)/;
        const match = e.message.match(regex);

        if (match) {
          const availableFunds = ethers.BigNumber.from(match[1]); // Available funds in wei
          const requiredFunds = ethers.BigNumber.from(match[2]); // Required funds in wei

          // Calculate the deficit
          // const deficit = requiredFunds - availableFunds;
          const selectedPickupNetwork = filterNetworksForFromSection().find(
            (el) => el.isSelected
          )
          setSnackBar({ message: `Not enough funds. Minimum of ${Number(ethers.utils.formatEther(requiredFunds)).toFixed(7)} ${selectedPickupNetwork.currency} bridge fee and Gas required`, type: "danger" });
          setTimeout(() => {
            //setSnackBar({});
          }, 6000);
        };
      }
      if (e?.data?.message?.includes("insufficient funds for gas * price + value")) {
        // Extract values from the error message using regular expressions
        const regex = /have (\d+) want (\d+)/;
        const match = e.data.message.match(regex);

        if (match) {
          const availableFunds = ethers.BigNumber.from(match[1]); // Available funds in wei
          const requiredFunds = ethers.BigNumber.from(match[2]); // Required funds in wei

          // Calculate the deficit
          // const deficit = requiredFunds - availableFunds;
          const selectedPickupNetwork = filterNetworksForFromSection().find(
            (el) => el.isSelected
          )
          setSnackBar({ message: `Not enough funds. Minimum of ${Number(ethers.utils.formatEther(requiredFunds)).toFixed(7)} ${selectedPickupNetwork.currency} bridge fee and Gas required`, type: "danger" });
          setTimeout(() => {
            //setSnackBar({});
          }, 6000);
        };

        return false;
      }

    }
  }


  useEffect(() => {
    getFees();
  }, [CCPoolContract, wallet, netWroks, connectedChain]);




  useEffect(() => {
    if (wallet) {
      const intervalId = setInterval(() => {
        updateToBalance();
        updateFromBalance();
        setCount((prevCount) => prevCount + 1);
      }, 1000);
      // Clear the interval when the count reaches maxCount or component unmounts
      return () => clearInterval(intervalId);
    }
  }, [count]);


  return (
    <div className="flex flex-col justify-between h-full ">
      {/* <p>{transAmount}</p> */}
      <div className="flex flex-col gap-2 ">
        <div className="text-sm">From</div>
        <div className="">
          <FromNetWork
            netWroks={filterNetworksForFromSection()}
            setNetWroks={setNetWroks}
            setTransAmount={setTransAmount}
            transAmount={transAmount}
            handleClickOnMaxAmout={handleClickOnMaxAmout}
            setIsInvalid={setIsInvalid}
            isInvalid={isInvalid}
            fromBalance={fromBalance}
          />
        </div>
        <div className=" flex justify-center">
          <div
            onClick={handleOnSwapClick}
            className="font-extrabold flex hover:cursor-pointer bg-sunny-primary dark:bg-dark-primary mt-[0.1rem] py-[0.6rem] px-[0.7rem] rounded"
          >
            <SwapVert className={`transform ${swapRotation.fist}`} />
            <SwapVert className={`transform ${swapRotation.second}`} />
          </div>
        </div>
        <div className="text-sm">To</div>
        <div className="bg-sunny-primary dark:bg-dark-primary rounded-lg">
          <ToNetworkContainer
            netWroks={filterNetworksForToSection()}
            setNetWroks={setNetWroks}
            toBalance={toBalance}
          />
        </div>
      </div>
      <div className="text-sm">
        <BillContainer
          networks={filterNetworksForFromSection()}
          bridgeFee={bridgeFee}
          gasFee={gasFee}
        ></BillContainer>
      </div>
      <div className="">
        <MFEButton
          // label={`Move From ${
          //   filterNetworksForFromSection().find((el) => el.isSelected)?.label || "bsc"
          // } to ${
          //   filterNetworksForToSection().find((el) => el.isSelected)?.label || "bsc"
          // }`}
          label={message}
          onClick={handleOnClick}
          disabled={isInvalid || isPending}
          color={lowBalance ? "red" : undefined}



        />

      </div>
      {errorMessage && (
        <ErrorDisplay
          message={errorMessage}
          onClose={() => setErrorMessage("")}
        />
      )}
      {isConnectionError && (
        <ConnectWalletError
          message={errorMessage}
          onClose={() => setIsConnectionError(false)}
        />
      )}

    </div>

  );
}

export default BridgeContainer;
